'use strict';

var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _require = require('./pipeline'),
  pipeline = _require.pipeline;
var Duplex = require('./duplex');
var _require2 = require('./destroy'),
  destroyer = _require2.destroyer;
var _require3 = require('./utils'),
  isNodeStream = _require3.isNodeStream,
  isReadable = _require3.isReadable,
  isWritable = _require3.isWritable,
  isWebStream = _require3.isWebStream,
  isTransformStream = _require3.isTransformStream,
  isWritableStream = _require3.isWritableStream,
  isReadableStream = _require3.isReadableStream;
var _require4 = require('../../ours/errors'),
  AbortError = _require4.AbortError,
  _require4$codes = _require4.codes,
  ERR_INVALID_ARG_VALUE = _require4$codes.ERR_INVALID_ARG_VALUE,
  ERR_MISSING_ARGS = _require4$codes.ERR_MISSING_ARGS;
var eos = require('./end-of-stream');
module.exports = function compose() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  if (streams.length === 0) {
    throw new ERR_MISSING_ARGS('streams');
  }
  if (streams.length === 1) {
    return Duplex.from(streams[0]);
  }
  var orgStreams = [].concat(streams);
  if (typeof streams[0] === 'function') {
    streams[0] = Duplex.from(streams[0]);
  }
  if (typeof streams[streams.length - 1] === 'function') {
    var idx = streams.length - 1;
    streams[idx] = Duplex.from(streams[idx]);
  }
  for (var n = 0; n < streams.length; ++n) {
    if (!isNodeStream(streams[n]) && !isWebStream(streams[n])) {
      // TODO(ronag): Add checks for non streams.
      continue;
    }
    if (n < streams.length - 1 && !(isReadable(streams[n]) || isReadableStream(streams[n]) || isTransformStream(streams[n]))) {
      throw new ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be readable');
    }
    if (n > 0 && !(isWritable(streams[n]) || isWritableStream(streams[n]) || isTransformStream(streams[n]))) {
      throw new ERR_INVALID_ARG_VALUE("streams[".concat(n, "]"), orgStreams[n], 'must be writable');
    }
  }
  var ondrain;
  var onfinish;
  var onreadable;
  var onclose;
  var d;
  function onfinished(err) {
    var cb = onclose;
    onclose = null;
    if (cb) {
      cb(err);
    } else if (err) {
      d.destroy(err);
    } else if (!readable && !writable) {
      d.destroy();
    }
  }
  var head = streams[0];
  var tail = pipeline(streams, onfinished);
  var writable = !!(isWritable(head) || isWritableStream(head) || isTransformStream(head));
  var readable = !!(isReadable(tail) || isReadableStream(tail) || isTransformStream(tail));

  // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.
  d = new Duplex({
    // TODO (ronag): highWaterMark?
    writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
    readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
    writable: writable,
    readable: readable
  });
  if (writable) {
    if (isNodeStream(head)) {
      d._write = function (chunk, encoding, callback) {
        if (head.write(chunk, encoding)) {
          callback();
        } else {
          ondrain = callback;
        }
      };
      d._final = function (callback) {
        head.end();
        onfinish = callback;
      };
      head.on('drain', function () {
        if (ondrain) {
          var cb = ondrain;
          ondrain = null;
          cb();
        }
      });
    } else if (isWebStream(head)) {
      var _writable = isTransformStream(head) ? head.writable : head;
      var writer = _writable.getWriter();
      d._write = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(chunk, encoding, callback) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return writer.ready;
              case 3:
                writer.write(chunk).catch(function () {});
                callback();
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                callback(_context.t0);
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 7]]);
        }));
        return function (_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();
      d._final = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(callback) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return writer.ready;
              case 3:
                writer.close().catch(function () {});
                onfinish = callback;
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                callback(_context2.t0);
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 7]]);
        }));
        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
    var toRead = isTransformStream(tail) ? tail.readable : tail;
    eos(toRead, function () {
      if (onfinish) {
        var cb = onfinish;
        onfinish = null;
        cb();
      }
    });
  }
  if (readable) {
    if (isNodeStream(tail)) {
      tail.on('readable', function () {
        if (onreadable) {
          var cb = onreadable;
          onreadable = null;
          cb();
        }
      });
      tail.on('end', function () {
        d.push(null);
      });
      d._read = function () {
        while (true) {
          var buf = tail.read();
          if (buf === null) {
            onreadable = d._read;
            return;
          }
          if (!d.push(buf)) {
            return;
          }
        }
      };
    } else if (isWebStream(tail)) {
      var _readable = isTransformStream(tail) ? tail.readable : tail;
      var reader = _readable.getReader();
      d._read = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$reader$read, value, done;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!true) {
                _context3.next = 19;
                break;
              }
              _context3.prev = 1;
              _context3.next = 4;
              return reader.read();
            case 4:
              _yield$reader$read = _context3.sent;
              value = _yield$reader$read.value;
              done = _yield$reader$read.done;
              if (d.push(value)) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("return");
            case 9:
              if (!done) {
                _context3.next = 12;
                break;
              }
              d.push(null);
              return _context3.abrupt("return");
            case 12:
              _context3.next = 17;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return");
            case 17:
              _context3.next = 0;
              break;
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 14]]);
      }));
    }
  }
  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError();
    }
    onreadable = null;
    ondrain = null;
    onfinish = null;
    if (onclose === null) {
      callback(err);
    } else {
      onclose = callback;
      if (isNodeStream(tail)) {
        destroyer(tail, err);
      }
    }
  };
  return d;
};